import { render, staticRenderFns } from "./TaskTableRow.vue?vue&type=template&id=3d5ad3d5&"
import script from "./TaskTableRow.vue?vue&type=script&lang=ts&"
export * from "./TaskTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports